module.exports = __webpack_public_path__ + "static/media/calculator-alt.681fdd53.svg";